// Copyright (c) 2016 Deere & Company

import SearchByDropDown from '@deere/cps-it.warranty-model-factory/lib/search-by-dropdown';

export const getDefaultState = () =>
    new SearchByDropDown({
        searchBy: [
            {
                key: 'CLAIM',
                value: 'CLAIM_NUMBER'
            },
            {
                key: 'WORK_ORDER',
                value: 'WORK_ORDER_ONE'
            },
            {
                key: 'FAILURE_PART',
                value: 'FAILED_PART'
            },
            {
                key: 'PIN',
                value: 'PIN'
            }
        ],
        selectedOption: {
            key: 'WORK_ORDER',
            value: 'WORK_ORDER'
        }
    });

export default SearchByDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/state/search-by-dropdown.js